export enum SkillType {
  WRITE = 'write',
  READ = 'read',
  LISTEN = 'listen',
  ORAL = 'oral',
}
